import { Container, Row } from "reactstrap";
import BasicTimeline from "./BasicTimeline";
import HoverTimeline from "./HoverTimeline";
import VariationTimeline from "./VariationTimeline";
import HorizontalTimeline from "./HorizontalTimeline";
import TimelineMain from "./TimelineMain";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, TimelineTitle } from "../../../Constants/Constants";

const TimelineContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TimelineTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicTimeline />
          <HoverTimeline />
          <VariationTimeline />
          <HorizontalTimeline />
          <TimelineMain />
        </Row>
      </Container>
    </>
  );
};
export default TimelineContainer;
